import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="spinner-container center">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default LoadingSpinner;
